import type { SVGProps } from 'react';

export function DumpsterFireIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m6.161 4.8-.96 4.8H2.1a.9.9 0 0 1-.9-.9v-.154q0-.144.045-.285l.949-2.846a.9.9 0 0 1 .855-.615zm.878 4.8.96-4.8H11.1v4.8zM12.9 4.8h3.101l.6 3a2.34 2.34 0 0 0-1.533.596q-.65.58-1.23 1.204h-.934V4.8zm-.555 6.6q-.36.496-.664.986C10.88 13.688 10.2 15.24 10.2 16.73c0 .641.079 1.267.225 1.871H5.91l.071.386a1.2 1.2 0 1 1-2.362.428c-.956-5.265-1.444-7.935-1.455-8.014zM22.8 8.7a.9.9 0 0 1-.656.866l-.098-.09a2.36 2.36 0 0 0-2.925-.206 14 14 0 0 0-.483-.472l-.8-3.998h3.113c.386 0 .732.248.855.615l.949 2.846c.03.09.045.188.045.285zm-3.836 2.711.461-.517c.203-.229.499-.33.784-.334.27 0 .536.098.746.292a11 11 0 0 1 2.063 2.648c.566 1.02.982 2.179.982 3.304a5.98 5.98 0 0 1-6 5.992c-3.36 0-6-2.674-6-5.992 0-1.399.6-2.753 1.38-3.919.784-1.174 1.781-2.213 2.659-3.007.213-.195.491-.29.761-.282s.502.12.705.282c.54.427 1.459 1.526 1.459 1.526zm1.436 7.197c0-1.37-1.387-2.738-2.055-3.315a.52.52 0 0 0-.694 0c-.663.577-2.055 1.946-2.055 3.315 0 1.323 1.076 2.4 2.4 2.4s2.4-1.077 2.4-2.4z" />
    </svg>
  );
}
